export default "/fonts/vendor/fontsource-roboto/files/roboto-greek-400-italic.woff2?aeaac920d76d2f3697cad159686728df";